import React, {useEffect, useState} from 'react';
import NewPageLoader from '../../components/page-loader/';
import {connect} from 'react-redux';
import {functionalitiesAliasMap, strings} from '../../util/strings';
import * as fonts from '../../util/fonts';
import colors from '../../util/colors';
import './styles.scss';
import {createGUID} from '../../util/utility';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

interface LegalInformationProps {
  stringsLoaded: boolean;
  labels: typeof strings.pt.legalInformation;
  selectedBu: any;
  busFuncMap: any;
  globalStyles: any;
}

const LegalInformation = ({
  stringsLoaded,
  labels,
  selectedBu,
  busFuncMap,
  globalStyles,
}: LegalInformationProps) => {
  const allStrings = {...strings.pt.legalInformation, labels};
  const [legalInfo, setLegalInfo] = useState([]);

  useEffect(() => {
    busFuncMap[selectedBu.buId]?.map((func: any) => {
      var legalList: any = [];
      if (
        func.featureTemplateAlias ===
          functionalitiesAliasMap.legalInformation &&
        func.isVisible
      ) {
        func.labels?.map((info: any) => {
          if (info.type === 'LEGALINFO') {
            legalList.push(info);
          }
        });
        setLegalInfo(
          legalList.filter((info: any) => info.url !== '' && info.url !== null)
        );
      }
    });
  }, [selectedBu, busFuncMap]);

  return localStorage.getItem('access_token') === '' || !stringsLoaded ? (
    <div className="loading-page-container">
      <NewPageLoader />
    </div>
  ) : (
    <div className="legal-info-container">
      <h1
        style={{
          ...fonts.XL,
          ...fonts.Bold,
          color: colors.black,
        }}>
        {allStrings?.legalInformation_title}
      </h1>
      <p style={{...fonts.SM}}>{allStrings.legalInformation_subtitle}</p>
      {legalInfo?.map((info: any, index: any) => {
        return (
          <a
            className="legal-info-items"
            key={createGUID()}
            href={info.url}
            target="_blank">
            <OpenInNewIcon sx={{color: globalStyles?.primaryColor}} />
            <p style={{...fonts.M, color: globalStyles?.primaryColor}}>
              {info.text}
            </p>
          </a>
        );
      })}
    </div>
  );
};

const mapStateToProps = ({
  stringsLoaded,
  strings,
  selectedBu,
  busFuncMap,
  globalStyles,
}: any) => ({
  stringsLoaded: stringsLoaded.value,
  labels: strings.value.pt.legalInformation,
  selectedBu: selectedBu.value,
  busFuncMap: busFuncMap.value,
  globalStyles: globalStyles.value,
});

export default connect(mapStateToProps)(LegalInformation);
